import React, { useState } from 'react';
import { FiRepeat, FiCopy, FiCheck, FiSearch, FiVolume2 } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const phraseMap = [
  { en: "I need to speak with my boss.", es: "Necesito hablar con mi jefe." },
  { en: "How can I improve my pronunciation?", es: "¿Cómo puedo mejorar mi pronunciación?" },
  { en: "I am looking for a remote job.", es: "Estoy buscando un trabajo remoto." },
  { en: "The meeting starts in ten minutes.", es: "La reunión comienza en diez minutos." },
  { en: "Can you repeat that, please?", es: "¿Puedes repetir eso, por favor?" },
  { en: "I would like to schedule a class.", es: "Me gustaría agendar una clase." },
  { en: "What is your current level?", es: "¿Cuál es tu nivel actual?" },
  { en: "Welcome to the campus lobby.", es: "Bienvenido al lobby del campus." },
  { en: "I have a question about grammar.", es: "Tengo una duda sobre gramática." },
  { en: "Let's practice conversational English.", es: "Practiquemos inglés conversacional." }
];

const Translator = () => {
  const [mode, setMode] = useState('en-es'); 
  const [searchTerm, setSearchTerm] = useState('');
  const [copied, setCopied] = useState(null);

  const filtered = phraseMap.filter(p => 
    p.en.toLowerCase().includes(searchTerm.toLowerCase()) || 
    p.es.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-6 shadow-2xl relative overflow-hidden group">
      <div className="absolute top-0 right-0 p-10 bg-green-500/5 blur-[80px] pointer-events-none"></div>
      
      <div className="flex items-center justify-between mb-6 relative">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-green-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-green-900/20">
            <SafeIcon icon={FiRepeat} />
          </div>
          <div>
            <h3 className="text-lg font-black text-white uppercase leading-none">Traductor Smart</h3>
            <p className="text-[10px] text-gray-500 font-bold uppercase tracking-widest">Frases del Campus</p>
          </div>
        </div>
        <button 
          onClick={() => setMode(mode === 'en-es' ? 'es-en' : 'en-es')}
          className="bg-black px-4 py-1.5 rounded-full text-[10px] font-black text-yellow-500 uppercase border border-zinc-800 hover:border-yellow-500 transition-all flex items-center gap-2"
        >
          {mode === 'en-es' ? 'ENG ➔ ESP' : 'ESP ➔ ENG'}
        </button>
      </div>

      <div className="relative mb-4">
        <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
        <input 
          type="text" 
          placeholder="Buscar frase..."
          className="w-full bg-black border border-zinc-800 rounded-xl py-3 pl-10 pr-4 text-sm text-white focus:outline-none focus:border-green-500 transition-all"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="space-y-2 max-h-[220px] overflow-y-auto pr-2 custom-scrollbar relative">
        {filtered.map((phrase, i) => (
          <div key={i} className="bg-black/40 border border-zinc-800 p-3 rounded-xl group/item hover:border-zinc-600 transition-all">
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <p className="text-xs font-bold text-white mb-1">
                  {mode === 'en-es' ? phrase.en : phrase.es}
                </p>
                <p className="text-[11px] text-gray-500 italic">
                  {mode === 'en-es' ? phrase.es : phrase.en}
                </p>
              </div>
              <div className="flex gap-1">
                <button 
                  onClick={() => handleCopy(mode === 'en-es' ? phrase.es : phrase.en, i)}
                  className="text-gray-600 hover:text-green-500 p-1.5 bg-zinc-900 rounded-lg"
                >
                  <SafeIcon icon={copied === i ? FiCheck : FiCopy} />
                </button>
              </div>
            </div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="text-center py-10 text-gray-600 text-xs italic">
            No se encontraron frases. Intenta con otra palabra.
          </div>
        )}
      </div>
    </div>
  );
};

export default Translator;